module.exports = __webpack_public_path__ + "526bd9213380a4bce354798ac4b958af.svg";